import { Config } from "@cleeng/mediastore-sdk";
import React, { useEffect, useState } from "react";
import ArrowDown from "../icons/ArrowDown";
import Japan from "../icons/Japan";
import UnitedStates from "../icons/UnitedStates";
const languages = [
  {
    name: "English (US)",
    code: "en-US",
    icon: <UnitedStates />
  },
  {
    name: "Japanese (JP)",
    code: "ja-JP",
    icon: <Japan />
  }
]
export const LanguageSelect = () => {
  const [selected, setSelected] = useState(languages[0]);
  const [show, setShow] = useState(false);

  const handleSelect = (language) => {
    setSelected(language);
    Config.setLanguage(language.code);
    window.location.reload();
    handleHide(false);
  }
  const handleShow = () => {
    setShow(!show)
  }
  const handleHide = () => {
    setShow(false)
  }
  useEffect(() => {
    const init = languages.find(l => l.code === localStorage.getItem("i18nextLng"))
    if(init) {
      setSelected(init)
    }
  }, [])
  return (
    <div className="language-wrapper">
      <div className="dropdown" onBlur={handleHide} tabIndex="0">
        <div className="dropbtn" onClick={handleShow}>
          {selected && selected.icon} {" "}
          {selected && selected.name} {" "}
          <ArrowDown width={10} height={10} />
        </div>
        <div className={`dropdown-content ${show ? 'show' : ''}`}>
          {languages.map((language) => <div className="dropdown-item" onClick={() => handleSelect(language)} key={language.code}>{language.icon} {language.name}</div>)}
        </div>
      </div>
    </div>
  );
};
